export const DEFAULT_TEAM_PAGE = {
  title: "Board of Directors",
  slug: "team",
  status: "published",
  hero_image_url: "/assets/board/dr-levard-roberts-executive-medical-director.jpg",
  seo_title: "Board of Directors | Bahamas Kidney Association",
  seo_description:
    "Meet the Board of Directors and leadership supporting the Bahamas Kidney Association's mission across The Bahamas.",
  body_json: {
    hero: {
      overline: "Our Leadership",
      heading_line_1: "Meet the People",
      heading_line_2: "Behind the Mission.",
      subheading:
        "Our board brings healthcare, financial, community and organisational leadership together in service of kidney health across The Bahamas.",
    },
    sections: [
      {
        type: "team",
        title: "Board of Directors",
        text: "Committed leadership. Shared purpose. A healthier Bahamas.",
        members: [
          {
            name: "Tamika Roberts",
            role: "Founder & President",
            image_url: "/assets/board/tamika-roberts-president.jpg",
            image_position: "center top",
            bio: "",
          },
          {
            name: "Irene Pintard",
            role: "Vice President",
            image_url: "/assets/board/irene-pintard-vice-president.jpg",
            image_position: "center top",
            bio: "",
          },
          {
            name: "Peter Rutherford, CPA",
            role: "Treasurer",
            image_url: "/assets/board/peter-rutherford-treasurer.jpg",
            image_position: "70% top",
            bio: "",
          },
          {
            name: "Dr. Levard Roberts",
            role: "Executive Medical Director",
            image_url: "/assets/board/dr-levard-roberts-executive-medical-director.jpg",
            image_position: "72% top",
            bio: "",
          },
          {
            name: "Mildred Johnson",
            role: "Secretary",
            image_url: "/assets/board/mildred-johnson-secretary.jpg",
            image_position: "center top",
            bio: "",
          },
        ],
      },
    ],
  },
};
